<template>
  <div :class="`popups popups--${state}`">
    <component
      v-for="(popup, index) in popups"
      is="popup"
      v-bind="popup"
      :key="index"
    ></component>
  </div>
</template>

<script>
import Base from "./Base";

export default {
  extends: Base,
  data() {
    return {
      state: "closed",
      popups: [],
    };
  },
  created() {
    this.$on("popup.closed", () => {
      this.state = "closed";
    });
  },
  methods: {
    popup(props) {
      this.state = "opened";
      this.popups.push(props);
    },
    confirm(text, onConfirm, buttonsConfiguration = {}) {
      return new Promise((resolve) => {
        this.popup({
          title: this.__("main.popups.confirm.title"),
          text: text,
          buttons: [
            {
              text: this.__("main.common.yes"),
              cssClass: "btn btn-next",
              handler: (popup) => {
                resolve(true);

                if (typeof onConfirm == "function") {
                  onConfirm(popup);
                } else if (typeof onConfirm == "object") {
                  if ("url" in onConfirm) {
                    fetch(onConfirm.url, {
                      headers: {
                        Accept: "application/json",
                      },
                    })
                      .then((resp) => {
                        return resp.json();
                      })
                      .then((data) => {
                        if ("success" in data && data.success) {
                          onConfirm.success();
                        }
                        popup.close();
                      });
                  }
                }
              },
              ...("confirm" in buttonsConfiguration
                ? buttonsConfiguration.confirm
                : {}),
            },
            {
              text: this.__("main.common.no"),
              cssClass: "btn btn-secondary",
              handler: (popup) => {
                resolve(false);
                popup.close();
              },
              ...("cancel" in buttonsConfiguration
                ? buttonsConfiguration.confirm
                : {}),
            },
          ],
        });
      });
    },
  },
};
</script>

<style lang="scss">
.popups {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 11;

  &--closed {
    display: none;
  }

  &--opened {
    display: block;
    z-index: 35;
  }
}
</style>